import React, { useState, useEffect, useContext } from "react";
import { FaWindowClose } from "react-icons/fa";
import { Card, CardBody } from "reactstrap";
import { ApiContext } from "../apiContext";
import AddForm from "./AddForm";
import { getToken } from "../../auth/AuthService";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { useLoader } from "../../helper/Loader";
import notify from "../../helper/Notify";
import { isSpecialCharacter } from "../../helper/CommonFunction";
import Permission from "./Permission";


const Service = ({ closeModal, modalData, setModalData}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  const { data, error, setData } = useContext(ApiContext);
  const {setIsLoader} = useLoader();
  const [formError, setFormError] = useState({});
  const apiBaseUrl = window.API_CONFIG.All_Api.users;
  const token = getToken();

  const generateUUID = () => {
    const uuid = uuidv4();
    const fiveDigitUUID = uuid.replace(/-/g, "").substr(0, 5);
    return fiveDigitUUID;
  };

  const [addCase, setCase] = useState({
    name: "",
    password: "",
    emailId:"",
    role:"user",
    permission:[],
    code: generateUUID(),
  });


  /*---- get all the input field ----*/
  const getInputValue = (field) => {
    return modalData ? modalData[field] : addCase[field];
  };
  /*---- change input field function ----*/

  
  const handleInputChange = (event, field) => {
    const { value } = event.target;
    if (modalData) {
      setModalData((prevModalData) => ({
        ...prevModalData,
        [field]: value,
      }));
    } else { 
      setCase((prevAddCase) => ({
        ...prevAddCase,
        [field]: value,
      }));
    }
  };


  /*---- handle clear function----*/
  const handleClear = () => {
    const clearfields = {
      name: "",
    password: "",
    email:"",
    permission:[],
    };
    if (!modalData) {
      setCase(clearfields);
    } else {
      setModalData((prevModalData) => ({
        ...prevModalData,
        ...clearfields,
      }));
    }
  };

  /*---- validation on form fields----*/
const validateFormFields = () => {
  const errors = {};
  const fieldarr = ["name", "emailId"];

  fieldarr.forEach((field) => {
    const value = modalData ? modalData[field] : addCase?.[field];

    if (value === "") {
      errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required.`;
    } else if (field === "emailId") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        errors[field] = "Please enter a valid email address.";
      }
    }
  });

  return errors;
};

  const isBase64 = (str) => {
  try {
    return typeof str === 'string' &&
      str.length % 4 === 0 &&
      /^[A-Za-z0-9+/]+={0,2}$/.test(str) &&
      btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};

  
  /* form submit function*/
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formErrors = validateFormFields();

    if (Object.keys(formErrors).length > 0) {
      setFormError(formErrors);
      notify.warning();
      return; 
    }

    setFormError("");
    setIsLoader(true);
    try {
      if (modalData) {
        const updatedModalData = { ...modalData};
        const updatedData = {
          ...updatedModalData,
          updatedDate: new Date().toISOString().slice(0, 10),
        password: modalData.password
  ? isBase64(modalData.password)
    ? modalData.password
    : btoa(modalData.password)
  : "",
        };

        try {
          const response = await axios.get(apiBaseUrl, {
            headers: {
              "x-access-token": token,
            },
          });

          const careerData = response.data?.data || [];
          const updatedCareerData = careerData.map((item) =>
            item.code === modalData.code ? { ...item, ...updatedData } : item
          );
          const duplicateItem = careerData.find(
            (item) =>
              item.name === modalData.name && item.code !== modalData.code
          );

          if (duplicateItem) {
            notify.error("Data is a duplicate and cannot be updated.");
            return;
          }
          if (isSpecialCharacter(modalData.name.charAt(0))){
            notify.error("Name should not start with special character");
               return;
          }

          const updateResponse = await axios.post(
            apiBaseUrl,
             updatedCareerData,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-access-token": token,
              },
            }
          );

          console.log("Data successfully updated:", updateResponse.data);
          if(updateResponse.data.success === true){
          setData((prevData) => ({
            ...prevData,
            users: updatedCareerData,
          }));
          closeModal();
          notify.success(updateResponse.data.message);
          setCase({}); 
        }
        else{
          notify.error(updateResponse.data.message);
        }
        } catch (error) {
          console.error("Error updating data:", error);
          notify.error(error.message);
        }
      } else {
        // Adding a new data entry
        const updatedBlogData = {
          ...addCase,
          createdDate: new Date().toISOString().slice(0, 10),
          password: addCase.password
  ? isBase64(addCase.password)
    ? addCase.password
    : btoa(addCase.password)
  : "",
        };

        try {
          const response = await axios.get(apiBaseUrl, {
            headers: {
              "x-access-token": token,
            },
          });

          // const oldData = response.data?.data || [];
                 const oldData = response.data?.data || [];
          const duplicateItem = oldData.find(
            (item) => item.name === addCase.name
          );

          if (duplicateItem) {
            notify.error("Data is a duplicate and cannot be added.");
            return;
          }

          if (isSpecialCharacter(addCase.name.charAt(0))){
            notify.error("Name should not start with special character");
               return;
          }

          const updatedData = [...oldData, updatedBlogData];

          const addResponse = await axios.post(
            apiBaseUrl,
            updatedData,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-access-token": token,
              },
            }
          );

          console.log("New data added successfully:", addResponse.data);
          if(addResponse.data.success === true){
          setData((prevData) => ({
            ...prevData,
            users: updatedData,
          }));

          closeModal();
          notify.success(addResponse.data.message);

          setCase({}); 
        }
        else{
          notify.error(addResponse.data.message);
        }
        } catch (error) {
          console.error("Error adding new data:", error);
          notify.error(error.message);
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
      notify.error(error.message);
    }
    finally{
      setIsLoader(false)
    }
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>{modalData ? `Manage Permissions - ${modalData.name}` : "Add New User"}</h1>
          <div className="close-icon">
            <FaWindowClose onClick={closeModal} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
                <AddForm
                handleSubmit={handleSubmit}
                formError={formError}
                getInputValue={getInputValue}
                handleInputChange={handleInputChange}
                handleClear={handleClear}
                modalData={modalData}
                addCase={addCase}
                setModalData={setModalData}
                setCase={setCase}
                country={data.country}
                maileventtype={data.maileventtype}
                closeModal={closeModal}
              />
              
            </CardBody>
            <div className="avc"></div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Service;
